import { render, staticRenderFns } from "./HeaderButtons.vue?vue&type=template&id=c070d7a8&scoped=true"
import script from "./HeaderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderButtons.vue?vue&type=script&lang=js"
import style0 from "./HeaderButtons.vue?vue&type=style&index=0&id=c070d7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c070d7a8",
  null
  
)

export default component.exports